import {
  type UserAttributesType
} from './Ambiguous'
import { LoadedUser } from './Loaded'

import { type LoadedRole } from '../../../../Foobara/Auth/Types/Role/Loaded'

import { type DomainAggregate } from '../../../../Foobara/Commandforge/Types/Domain/Aggregate'

import { type LoadedOrganization } from '../../../../Foobara/Commandforge/Types/Organization/Loaded'

export interface UserAggregateAttributesType extends UserAttributesType {
  id: number
  owned_organizations: LoadedOrganization[]
  member_of_organizations: LoadedOrganization[]
  owned_domains: DomainAggregate[]
  member_of_domains: DomainAggregate[]
  username?: string
  email?: string | null
  roles?: LoadedRole[]
}

export class UserAggregate extends LoadedUser<UserAggregateAttributesType> {
  /* eslint-disable @typescript-eslint/class-literal-property-style */
  get isAtom (): false { return false }
  get isAggregate (): true { return true }
  /* eslint-enable @typescript-eslint/class-literal-property-style */
}
